import { render, staticRenderFns } from "./CurrencyPreference.vue?vue&type=template&id=603184bc&"
import script from "./CurrencyPreference.vue?vue&type=script&lang=js&"
export * from "./CurrencyPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports